import { createContext } from 'react';
import { IItemDishesForGetInfo } from 'types';

export type TDishFullInfoVisibleForm = 'mainForm' | 'additionallyForm' | 'translationsForm';

export interface IDishFullInfoState {
	dishFullInfoVisibleForm: TDishFullInfoVisibleForm;
	dishForFullInfo: IItemDishesForGetInfo | null;
}

export const dishFullInfoInitialState: IDishFullInfoState = {
	dishFullInfoVisibleForm: 'mainForm',
	dishForFullInfo: null,
};

export interface IDishFullInfoContext extends IDishFullInfoState {
	changeDishFullInfoVisibleForm(value: TDishFullInfoVisibleForm): void;
}

export const DishFullInfoContext = createContext<IDishFullInfoContext>({
	changeDishFullInfoVisibleForm: () => undefined,
	...dishFullInfoInitialState,
});
